import { render, staticRenderFns } from "./SalesByPaymentType.vue?vue&type=template&id=4db9034a"
import script from "./SalesByPaymentType.vue?vue&type=script&lang=js"
export * from "./SalesByPaymentType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports